import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentLanguageTestActionsResponse = {
  isLocked: boolean
  hasSubmittedBefore: boolean
  hasAnActiveSubmission: boolean
}

export const getEnrollmentLanguageTestActions = (enrollmentId: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.getActions.url, { id: enrollmentId }))
    .get<EnrollmentLanguageTestActionsResponse>()
